var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7925 18.7474L15.6423 14.5971C16.9505 13.0516 17.7392 11.053 17.7392 8.8696C17.7392 3.97136 13.7678 0 8.8696 0C3.97136 0 0 3.97136 0 8.8696C0 13.7678 3.97136 17.7392 8.8696 17.7392C10.9672 17.7424 12.9975 16.9991 14.5971 15.6423L18.7474 19.7925C19.0374 20.0726 19.4984 20.0686 19.7835 19.7835C20.0686 19.4984 20.0726 19.0374 19.7925 18.7474ZM16.2609 8.8696C16.2609 12.9518 12.9518 16.2609 8.8696 16.2609C4.78737 16.2609 1.47827 12.9518 1.47827 8.8696C1.47827 4.78737 4.78737 1.47827 8.8696 1.47827C12.9518 1.47827 16.2609 4.78737 16.2609 8.8696Z",
    fill: "#204056"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.dff9f420.svg";
export { ForwardRef as ReactComponent };